import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import DriverETAContainer from './DriverETAContainer';

import ApiResponse from '../../../models/ApiResponse';
import PickupOrder from '../../../models/PickupOrder';
import ResponseError from '../../../models/ResponseError';

import { PO_SCHEMA } from '../../../utils/pickupOrder';
import DriverETAStyles from './driverETA.module.css';

interface DriverETAPageContainerProps {
  match: { params: { orderType: string, poNumber: string, secretKey: string } };
  history: any;
  receiveError: Function;
  receiveSuccess: Function;
};

interface DriverETAPageContainerState {
  po: PickupOrder;
  poNumber: string;
  secretKey: string;
  loading: boolean;
};

class DriverETAPageContainer extends Component<DriverETAPageContainerProps, DriverETAPageContainerState> {

  state = {
    po: PO_SCHEMA,
    poNumber: '',
    secretKey: '',
    loading: true
  }

  componentDidMount() {

    const poNumber: string = this.props.match.params.poNumber;
    const secretKey: string = this.props.match.params.secretKey;

    pickupOrderRemote.getAnonymousPickupOrder(poNumber, secretKey).then((resp: ApiResponse<PickupOrder>) => {

      const po: PickupOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        this.setState({ po, poNumber, secretKey, loading: false });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {
    if (this.state.loading)
      return null;
    return (
      <div className={ DriverETAStyles.driverETAWrapper }>
        <DriverETAContainer match={ this.props.match } history={ this.props.history } pickupOrder={ this.state.po } secretKey={ this.state.secretKey } />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(null, mapDispatchToProps)(DriverETAPageContainer);